const OM = () =>
  import('@/views/main/helper/om/OMTable.vue')
export default {
  path: '/main/helper/om',
  name: 'OM',
  component: OM,
  children: []
}
